import { defineMessage } from 'services/localization';

export const messages = {
    contactInformationSection: defineMessage('contact_information_1'),
    emailFieldText: defineMessage('email'),
    phoneFieldText: defineMessage('phone_1'),
    altPhoneFieldText: defineMessage('alt_phone'),
    faxFieldText: defineMessage('fax'),
    financialInformationSection: defineMessage('financial_information_1'),
    legalNameFieldText: defineMessage('legal_name'),
    accountNumberFieldText: defineMessage('account_number'),
    defaultExpenseAccountFieldText: defineMessage('default_expense_account'),
    defaultPayablesAccountFieldText: defineMessage('default_payables_account'),
    termsFieldText: defineMessage('terms'),
    creditLimitFieldText: defineMessage('credit_limit'),
    incotermFieldText: defineMessage('incoterm'),
    taxNumberFieldText: defineMessage('tax_id_2'),
    is1099EligibleFieldText: defineMessage('is_eligible'),
    isJobResourceFieldText: defineMessage('is_job_resource'),
    positiveValue: defineMessage('yes'),
    subsidiariesSection: defineMessage('subsidiaries'),
    primarySubsidiaryFieldText: defineMessage('primary_subsidiary'),
    currenciesSection: defineMessage('currencies'),
    primaryCurrencyFieldText: defineMessage('primary_currency'),
    currenciesListFieldText: defineMessage('currencies_list'),
    addressSection: defineMessage('address_section'),
};
